import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ArticlePage from "../pages/guides/best-pandabuy-spreadsheet-guide/page";
import SneakersGuide from "../pages/guides/sneakers/page";
import StreetwearGuide from "../pages/guides/streetwear/page";
import BudgetFinds from "../pages/guides/budget/page";
import AccessoriesGuide from "../pages/guides/accessories/page";
import QualityTips from "../pages/guides/quality/page";
import VsCompetitors from "../pages/guides/vs-competitors/page";
import BeginnerTips from "../pages/guides/beginner/page";
import TrendingProducts from "../pages/guides/trending/page";
import SafetyGuide from "../pages/guides/safety/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/guides/best-pandabuy-spreadsheet-guide",
    element: <ArticlePage />,
  },
  {
    path: "/guides/pandabuy-sheet-sneakers-guide",
    element: <SneakersGuide />,
  },
  {
    path: "/guides/pandabuy-sheet-streetwear-guide",
    element: <StreetwearGuide />,
  },
  {
    path: "/guides/pandabuy-sheet-budget-finds",
    element: <BudgetFinds />,
  },
  {
    path: "/guides/pandabuy-sheet-accessories-guide",
    element: <AccessoriesGuide />,
  },
  {
    path: "/guides/pandabuy-sheet-quality-tips",
    element: <QualityTips />,
  },
  {
    path: "/guides/pandabuy-sheet-vs-competitors",
    element: <VsCompetitors />,
  },
  {
    path: "/guides/pandabuy-sheet-beginner-tips",
    element: <BeginnerTips />,
  },
  {
    path: "/guides/pandabuy-sheet-trending-products",
    element: <TrendingProducts />,
  },
  {
    path: "/guides/pandabuy-sheet-safety-guide",
    element: <SafetyGuide />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;